export const treeViewReducerKey = 'treeViewReducerKey';

export const treeViewSetSelectedTaxonomiesReducerType = 'treeViewSetSelectedTaxonomiesReducerType';
export const treeViewSetSelectedListExpandedReducerType = 'treeViewSetSelectedListExpandedReducerType';
export const treeViewSetTaxonomiesReducerType = 'treeViewSetTaxonomiesReducerType';
export const treeViewSetInitialConfigReducerType = 'treeViewSetInitialConfigReducerType';

export const ALLOWED_TAGS_ARRAY = ['sub', 'sup', 'hi', 'i', 'br', 'span'];
